// extracted by mini-css-extract-plugin
export default {"menuIconButton":"index_menuIconButton__-1v3j","iconWrapper":"index_iconWrapper__Dh-G1","menuButtonText":"index_menuButtonText__OJeZ9"};